// This file is generated. DO NOT EDIT.
import type { TestDriver, TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import type { ElementLocator } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { SelectMultipleAdapter } from './SelectMultipleAdapter';

/**
 * Get the test adapter for the Preact SelectMultiple, identified by the given locator.
 * If a driverOrElement is given, the locator will be searched from there.
 * @param locator The ElementLocator used to search for the SelectMultiple
 * @param driverOrElement The optional TestDriver or TestElement from which to search. If
 * TestElement is given, locator will search underneath that element. If TestDriver is given
 * or the parameter is undefined, the DOM is searched globally.
 * @returns The test adapter for SelectMultiple
 */
export function findSelectMultiple(
  locator: ElementLocator,
  driverOrElement?: TestDriver | TestElement
) {
  return new SelectMultipleAdapter(locator, driverOrElement);
}
